
import { FETCH_SYNTHESE_REQUEST, FETCH_SYNTHESE_SUCCESS, FETCH_SYNTHESE_FAILURE } from './actionsTypes';

export const fetchSyntheseRequest = (token,history) => ({
  type: FETCH_SYNTHESE_REQUEST,
  payload: { token,history },
});

export const fetchSyntheseSuccess = (syntheseData) => ({
  type: FETCH_SYNTHESE_SUCCESS,
  payload: { syntheseData },
});

export const fetchSYNTHESEFailure = (error) => ({
  type: FETCH_SYNTHESE_FAILURE,
  payload: { error },
});

